/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import _ from "lodash"

export const getValueByLabel = <T = string | number | Date | null>(
  rows: readonly (readonly (string | number | null)[])[],
  label: string,
  converter?: (val: unknown) => T
): T => {
  const normalizedLabel = label.trim().toLowerCase()
  const result = rows.find(
    r => typeof r[0] === "string" && r[0].trim().toLowerCase() === normalizedLabel
  )?.[1]
  if (result === undefined) {
    // Label not found - this is expected in some cases
  }
  if (converter) {
    return converter(result)
  }
  return result as T
}
